import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6df4e05a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-categories-tree m-0 p-0 fw-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCategoriesTreeItem = _resolveComponent("ProductCategoriesTreeItem")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.categoriesTree.subcategories, (subCategory) => {
      return (_openBlock(), _createBlock(_component_ProductCategoriesTreeItem, {
        key: subCategory.description,
        "categories-tree-item": subCategory,
        onSelectCategory: this.selectCategory
      }, null, 8, ["categories-tree-item", "onSelectCategory"]))
    }), 128))
  ]))
}